// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_40mm_28mm_2_labels_layout__fdg43"};